import { callApi } from "src/core/callApi";
import { formatDate } from "src/utils/functions";

export const unsubscribeUser = async () => {
    const URL = 'https://4rbg8m6w65.execute-api.us-east-2.amazonaws.com/default/unsubscribe_v2';
    try {
      const response = await callApi(
        URL,
        {
          queryParams: {
            // isTest: true,
          },
        },
        true,
        false,
        '',
        'GET',
        true
      );

      if (response?.subscription_cancelled) {
        return true;
      } else {
        console.log('Unsubscription Failed!');
        return false;
      }
    } catch (err) {
      console.log('Unsubscription failed: ', err);
      return false;
    }
  };


export const getYearlyUpgradeSubscriptionDates = () => {
  const today = new Date();
  const oneYearFromNow = new Date(new Date(today).setFullYear(today.getFullYear() + 1));

  const formattedToday = formatDate(today.toISOString());
  const formattedOneYearFromNow = formatDate(oneYearFromNow.toISOString());

  return {
    startDate: formattedToday,
    endDate: formattedOneYearFromNow,
  };
};

export const getYearlyUpgradeSubscriptionDateString = () => {
  const dates = getYearlyUpgradeSubscriptionDates();
  return `Your yearly upgrade will begin on ${dates.startDate} and continue until ${dates.endDate}. After this period, you’ll be charged for the next 12 months at the standard rate, without the current discount.`;
};

